import {NgModule} from '@angular/core';
import {EnumTransformPipe} from './enumTransform/enum-transform.pipe';
import {FormMessageComponent} from './form-messasge/form-message.component';
import {CommonModule} from '@angular/common';
import {ByPassSecurityPipe} from './ByPassSecurityPipe/by-pass-security.pipe';

@NgModule({
    declarations: [EnumTransformPipe, FormMessageComponent, ByPassSecurityPipe],
    imports: [
        CommonModule
    ],
    exports: [EnumTransformPipe, FormMessageComponent, ByPassSecurityPipe]
})
export class SharedModuleModule {}
